import React, { useEffect } from 'react';
import { modalStyles } from '../styles/sharedStyles';

const Modal = ({
  isOpen,
  onClose,
  title,
  children,
  footer,
  width = '600px',
}) => {
  const [isClosing, setIsClosing] = React.useState(false);
  const [isCloseButtonHovered, setIsCloseButtonHovered] = React.useState(false);

  // Close on Escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  if (!isOpen && !isClosing) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const closeButtonStyle = {
    ...modalStyles.closeButton,
    ...(isCloseButtonHovered ? modalStyles.closeButtonHover : {}),
  };

  return (
    <div style={modalStyles.overlay} onClick={handleOverlayClick}>
      <div style={{ ...modalStyles.modal, maxWidth: width }}>
        {/* Header */}
        <div style={modalStyles.header}>
          <h2 style={modalStyles.title}>{title}</h2>
          <button
            onClick={onClose}
            style={closeButtonStyle}
            onMouseEnter={() => setIsCloseButtonHovered(true)}
            onMouseLeave={() => setIsCloseButtonHovered(false)}
            aria-label="Close modal"
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div style={modalStyles.body}>{children}</div>

        {/* Footer */}
        {footer && <div style={modalStyles.footer}>{footer}</div>}
      </div>
    </div>
  );
};

export default Modal;
